import PropTypes from "prop-types";
import { createContext, useState } from "react";
import { INITIAL_PLAYER_STATE } from "src/constants";
import { useImmer } from "use-immer";

const PlayerContext = createContext();

PlayerProvider.propTypes = {
  children: PropTypes.node,
};

function PlayerProvider({ children }) {
  const [minimized, setMinimized] = useImmer(false);
  const [videoData, setVideoData] = useImmer(null);
  const [playerRef, setPlayerRef] = useState(null);
  const [playerState, setPlayerState] = useImmer(INITIAL_PLAYER_STATE);

  const handleChangePlayerState = (ps) => {
    setPlayerState((draft) => {
      Object.keys(ps).forEach((k) => {
        draft[k] = ps[k];
      });
    });
  };

  const handleSeekTo = (value) => {
    console.log("seekTo: ", value, playerRef);
    setPlayerState({ playedSeconds: parseFloat(value) });
    playerRef.current.seekTo(parseFloat(value), "seconds");
  };

  return (
    <PlayerContext.Provider
      value={{
        minimized,
        setMinimized,
        videoData,
        setVideoData,
        playerState,
        playerRef,
        setPlayerRef,
        seekTo: handleSeekTo,
        setPlayerState: handleChangePlayerState,
      }}
    >
      {children}
    </PlayerContext.Provider>
  );
}

export { PlayerContext, PlayerProvider };
